






import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import {
  IRateRuleSelectListItem,
  NestedEditModel,
  RateRuleSelectListItem
} from '@/services/api/nswag/stapiclient_generated';
import RateRuleSelectNestedInner from '@/views/RateRules/RateRuleSelectNested/RateRuleSelectNestedInner.vue';

class RRSelectListItem extends RateRuleSelectListItem{
  selected: boolean | undefined;
  isOpen: boolean | undefined
  childItems: RRSelectListItem[] | undefined;
}

@Component({
  components: {
    RateRuleSelectNestedInner
  },
})
export default class RateRuleSelectNested extends Vue {
  @Prop()items!: RateRuleSelectListItem[];
  @Prop()value!: Array<NestedEditModel>;

  selectEditModels: RRSelectListItem[] = [];

  mounted(){
    this.selectEditModels = this.getSelectEditModels(this.items, this.value);
  }

  getSelectEditModels(selectItems: RateRuleSelectListItem[], editItems: NestedEditModel[]): RRSelectListItem[]{
    return selectItems.map(x=>{
      let res: any = {
        ...x,
        childItems: this.getSelectEditModels(x.childItems ?? [], editItems.find(y=>y.id == x.id)?.nestedIds ?? []),
        selected: editItems.some(y=>y.id == x.id),
        isOpen: false,
      };
      return res;
    });
  }

  allChildrenSelectedRecursive(childItems: RRSelectListItem[]): boolean{
    let allSelected = true;
    childItems.forEach(x=>{
      if(!x.selected || !this.allChildrenSelectedRecursive(x.childItems!)){
        allSelected = false;
      }
    })
    return allSelected;
  }

  allChildrenSelected(item: RRSelectListItem){
    return this.allChildrenSelectedRecursive(item.childItems!);
  }

  getEditModels(selectEditModels: RRSelectListItem[]):Array<NestedEditModel>{
    return selectEditModels.filter(x=>x.selected).map(x=>{

      let editModels = this.getEditModels(x.childItems!);
      let allSelected = this.allChildrenSelected(x);

      return NestedEditModel.fromJS({
        id: x.id,
        nestedIds: editModels,
        allSelected: allSelected
      })
    });
  }

  @Watch('selectEditModels' )
  selectEditModelsChanged(){
    this.$emit('input', this.getEditModels(this.selectEditModels));
  }


}
